var codeVerifierInit;

(function ($) {

	const selectors = {
		btn: '[data-verify-code]',
		input: '[data-code-input]',
		result: '[data-validate-result]',
		id: '[data-validate-id]',
		name: '[data-validate-name]',
		error: '[data-validate-error]',
		ok: '[data-validate-ok]'
	}

	codeVerifierInit = function () {
		$(selectors.btn).each((i, el) => {
			new CodeVerifier(el);
		});
	}

	class CodeVerifier {
		constructor(element) {
			this.$btn = $(element);

			this.init();

		}
		init() {

			this.$form = this.$btn.closest('form');
			this.$input = $(selectors.input, this.$form);
			this.$result = $(selectors.result, this.$form);
			this.$id_input = $(selectors.id, this.$form);
			this.$name_input = $(selectors.name, this.$form);
			this.$err = $(selectors.error, this.$form);
			this.$ok = $(selectors.ok, this.$form);

			this.bind();

		}

		bind() {
			this.verify = this.verify.bind(this);

			this.$btn.on('click', this.verify);

		}

		verify() {

			const self = this;

			if (self.$btn.hasClass('is-loading') || self.$form.hasClass('is-loading')) return;

			var data = {
				code: this.$input.val()
			};

			$.ajax({
				type: "POST",
				url: wp_params.ajax_url,
				data: {
					'action': 'verify_code',
					'args': data
				},
				beforeSend: _ => {

					this.$result.val('');

					self.$input.removeClass('is-valid is-invalid');
					self.$btn.addClass('is-loading');
					self.$input.addClass('is-loading');

					self.$err.hide();
					self.$ok.hide();
				},
				success: response => {
					if (response && response.success) {
						self.$result.val('1');
						self.$input.addClass('is-valid');
						self.$ok.show();
						if (response.voucher_id) {
							self.$id_input.val(response.voucher_id);
						}
						if (response.product) {
							self.$name_input.val(response.product);
						}
					}
					else {
						self.$input.addClass('is-invalid');
						self.$err.show();

					}
				},
				complete: _ => {
					self.$btn.removeClass('is-loading');
					self.$input.removeClass('is-loading');
				}
			});
		}

	}

})(jQuery);


export default codeVerifierInit;